import { ReactNode } from "react";
import "./config";

export interface WithDateConfigProps {
	children: React.ReactNode
}

export const WithDateConfig = (props: WithDateConfigProps): ReactNode => {
	const { children } = props;

	return children;
};
